export interface SecurityMeasureViewModel {
    id: string;
    name: string;
    description: string;
    securityMeasureType: SecurityMeasureType;
    isGlobal: boolean;
    isActive: boolean;
    isCustom: boolean;
    businessAreaIds: Array<string>;
    groupEntitiesIds: Array<string>;
    hasAllBusinessAreas: boolean;
    hasAllGroupEntities: boolean;
}

export interface SecurityMeasureSaveModel {
    name: string;
    description: string;
    securityMeasureType: number | undefined;
    isGlobal: boolean;
    isCustom: boolean;
    businessAreaIds: Array<string>;
    groupEntitiesIds: Array<string>;
}

export enum SecurityMeasureType {
    Organizational,
    LogicalSecurity,
    PhysicalSecurity,
    Technical,
    Contractual,
}
